import { Button, Grid, Skeleton, styled } from '@mui/material';

export const DashboardCard = styled(Grid)(({ theme }) => ({
  borderRadius: '8px',
  padding: '24px',
  background: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
}));

export const CardTitle = styled('span')({
  fontSize: '18px',
  lineHeight: '26px',
  fontWeight: 400,
});

export const StyledSkeleton = styled(Skeleton)(({ width, height, margin, theme }) => ({
  borderRadius: '4px',
  background: theme.palette.divider,
  width: '100%',
  height: height,
  margin: margin,
}));

export const CenterGrid = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const StyledGrid = styled(Grid)(({ props }) => ({
  ...props,
}));

export const StyledButton = styled(Button, {
  shouldForwardProp: prop =>
    !['textColor', 'hoverTextColor', 'bgColor', 'hoverBgColor', 'border'].includes(prop),
})(({ textColor, hoverTextColor, bgColor, hoverBgColor, border }) => ({
  color: textColor,
  backgroundColor: bgColor,
  border: border,
  textTransform: 'none',
  '&:hover': {
    color: hoverTextColor,
    backgroundColor: hoverBgColor,
    border: border,
  },
}));
